import React, { useContext, useEffect, useState } from "react"
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap"
import toast from "react-hot-toast"
import { useNavigate } from "react-router-dom"
import Delete from "../../../Components/Modals/DeleteModal"
import ApproveModal from "../../../Components/Modals/ApproveModal"
import Navbar from "../../../Components/Navbar/Navbar"
import Select from "react-select"
import {
  getType,
  numberFormat,
  refreshPage,
  selectDropdownStyle,
  toastStyle,
} from "../../../Helpers/Utils/Common"
import DatePicker from "react-datepicker"
import Moment from "moment"
import { getCustomer } from "../../../Helpers/apiCalls/Manage/CustomersApi"
import {
  voidBankSalesPayment,
  voidCashSalesPayment,
  voidCheckSalesPayment,
  voidOtherSalesPayment,
  deleteSalesInvoiceCashPayment,
  getSalesInvoicePayment,
} from "../../../Helpers/apiCalls/SalesModule/SalesInvoiceCashPayment"
import {
  deleteSalesInvoiceCheckPayment,
  updateCheckSlipStatus,
} from "../../../Helpers/apiCalls/SalesModule/SalesInvoiceCheckPayment"
import { deleteSalesInvoiceOtherPayment } from "../../../Helpers/apiCalls/SalesModule/SalesInvoiceOtherPayment"
import { deleteSalesInvoiceBankPayment } from "../../../Helpers/apiCalls/SalesModule/SalesInvoiceBankPayment"
import Footer from "../../../Components/Footer/Footer"
import VoidModal from "../../../Components/Modals/VoidModal"
import GenerateBirModal from "../../Purchases/PurchaseOrders/Components/GenerateBirModal"
import BirForm from "../../Purchases/Pay Suppliers/Components/BirForm"
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination"
import { Context } from "../../../Helpers/Utils/Context"
import moment from "moment"
export default function SalesPayments() {
  let navigate = useNavigate()
  const userType = getType()
  const { setDateFrom, setDateTo, dateFilter, currentTab, setCurrentTab } =
    useContext(Context)

  /* delete modal handler */
  const [statusValue, setStatusValue] = useState("")
  const [showApproveModal, setShowApproveModal] = useState(false)
  const handleShowApproveModal = (row, status) => {
    setSelectedRow(row)
    setStatusValue(status)
    setShowApproveModal(true)
  }

  const [showVoidModal, setShowVoidModal] = useState(false)
  const handleShowVoidModal = (row, status) => {
    setSelectedRow(row)
    setStatusValue(status)
    setShowVoidModal(true)
  }
  const handleCloseApproveModal = () => setShowApproveModal(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const handleShowDeleteModal = () => setShowDeleteModal(true)
  const handleCloseDeleteModal = () => refreshPage()
  const handleCloseVoidModal = () => refreshPage()
  const [showGenerateBirModal, setShowGenerateBirModal] = useState(false)
  const handleShowGenerateBirModal = () => setShowGenerateBirModal(true)
  const handleCloseGenerateBirModal = () => setShowGenerateBirModal(false)
  const [paymentDeets, setPaymentDeets] = useState({ id: "", payment: "" })
  const [selectedRow, setSelectedRow] = useState({})
  const [inactive, setInactive] = useState(true)
  const [filteredData, setFilteredData] = useState([])
  const [showLoader, setShowLoader] = useState(false)
  const [isClicked, setIsClicked] = useState(false)
  const [customers, setCustomers] = useState([])
  const [summary, setSummary] = useState([])
  const today = new Date()
  const aweekago = new Date()
  aweekago.setDate(aweekago.getDate() - 7)
  const [filterConfig, setFilterConfig] = useState({
    tab: currentTab ? currentTab : "pending",
    status: currentTab ? currentTab : "pending",
    date_from: dateFilter.date_from ? dateFilter.date_from : "",
    date_to: dateFilter.date_to ? dateFilter.date_to : "",
    supplier_id: "",
    payment_mode: "",
    customer_id_value: {
      label: "All customers",
      value: "",
    },
    page: 1,
  })
  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10 // Change this based on your requirement

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setFilterConfig((prev) => ({
      ...prev,
      page: page,
    }))
  }

  async function handleDeleteSP() {
    setIsClicked(true)
    var paymentMode = paymentDeets.payment.split("-")[0].trim()
    var response = {}
    if (paymentMode === "cash") {
      response = await deleteSalesInvoiceCashPayment(paymentDeets.id)
    } else if (paymentMode === "check") {
      response = await deleteSalesInvoiceCheckPayment(paymentDeets.id)
    } else if (paymentMode === "bank") {
      response = await deleteSalesInvoiceBankPayment(paymentDeets.id)
    } else if (paymentMode === "other") {
      response = await deleteSalesInvoiceOtherPayment(paymentDeets.id)
    }
    if (response.data) {
      toast.success(response.data.message, {
        style: toastStyle(),
      })
      setTimeout(() => refreshPage(), 1000)
    } else {
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data)
      })
      setTimeout(() => refreshPage(), 1000)
    }
  }

  async function handleVoidSP() {
    setIsClicked(true)
    var paymentMode = selectedRow.type
    var id = selectedRow.id
    var response = {}
    if (paymentMode === "cash") {
      response = await voidCashSalesPayment(id)
    } else if (paymentMode === "check") {
      response = await voidCheckSalesPayment(id)
    } else if (paymentMode === "bank") {
      response = await voidBankSalesPayment(id)
    } else if (paymentMode === "other") {
      response = await voidOtherSalesPayment(id)
    }

    if (response.data) {
      toast.success("Sales Payment Successfully Voided!", {
        style: toastStyle(),
      })
      setTimeout(() => refreshPage(), 1000)
    } else {
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data)
      })
      setTimeout(() => refreshPage(), 1000)
    }
    setIsClicked(false)
    // handleCloseVoidModal()
  }

  async function fetchCustomers() {
    setCustomers([])

    const response = await getCustomer({})
    if (response.data) {
      var customers = response.data.data.map((customer) => {
        var info = customer
        info.name = "customer_id"
        info.select_variable = "customer_id_value"
        info.label = customer.trade_name
        info.value = customer.id
        return info
      })
      setCustomers(customers)
    }
  }

  async function fetchData() {
    setShowLoader(true)
    setFilteredData([])
    setTotalItems(0)
    let allData = []

    try {
      const response = await getSalesInvoicePayment(filterConfig)

      if (response && response.data) {
        console.log(response)
        setSummary(response.data.total_amount)
        allData = response.data.data.map((data) => {
          var payment = { ...data }
          payment.type = payment.payment_mode
          payment.amount = numberFormat(payment.amount)
          payment.bank_name =
            payment.payment_mode === "bank"
              ? `${payment.bank_from_name || "N/A"} to ${
                  payment.bank_to_name || "N/A"
                }`
              : payment.bank_from_name || "N/A"
          payment.date =
            payment.date && payment.date !== "0000-00-00"
              ? Moment(payment.date).format("MMM DD, YYYY")
              : "N/A"
          payment.doc_no = payment.doc_no || "N/A"
          payment.issue_date =
            payment.issued_date && payment.issued_date !== "0000-00-00"
              ? Moment(payment.issued_date).format("MMM DD, YYYY")
              : "N/A"
          payment.payee = payment.payee || "N/A"
          payment.payment_mode =
            payment.payment_mode === "check"
              ? `${payment.payment_mode} - ${payment.check_no}`
              : payment.payment_mode === "bank"
              ? `${payment.payment_mode}${
                  payment.reference_no && payment.reference_no !== "undefined"
                    ? " - " + payment.reference_no
                    : ""
                }`
              : payment.payment_mode

          payment.supplier = payment.supplier || payment.vendor || "N/A"
          allData.push(payment)
          return payment
        })
        setFilteredData(allData)
        setTotalItems(response.data.size)
      } else {
        console.log("Unexpected response structure")
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    } finally {
      setShowLoader(false)
    }
  }

  console.log(totalItems)

  function handleSelectChange(e, row) {
    setSelectedRow(row)
    if (e.target.value === "edit-ps") {
      navigate(
        "/salespayment/edit/" + e.target.id + "/" + e.target.role.split("-")[0]
        // + "/" +
        // e.target.role.split("-")[1]
      )
    } else if (e.target.value === "delete-ps") {
      handleShowDeleteModal()
      setPaymentDeets({ id: e.target.id, payment: e.target.role })
    } else if (e.target.value === "view-ps") {
      navigate(
        "/salespayment/view/" + e.target.id + "/" + e.target.role.split("-")[0]
      )
    } else if (e.target.value === "return-ps") {
      handleShowApproveModal(row, "pending")
    } else if (e.target.value === "void-ps") {
      handleShowVoidModal(row, "void")
    } else if (e.target.value === "generate-bir") {
      handleShowGenerateBirModal()
    }
  }

  function ActionBtn(row, type) {
    return (
      <Form.Select
        name="action"
        role={`${row.payment_mode}`}
        id={row.id}
        className="PO-select-action"
        onChange={(e) => handleSelectChange(e, row)}
      >
        <option value="" selected hidden>
          Select
        </option>
        <option value="view-ps" className="color-options">
          View
        </option>
        <option value="void-ps" className="color-options">
          Void
        </option>
        {row.withholding_tax_total !== "0.0000" ? (
          <option value="generate-bir" className="color-options">
            Generate BIR 2307
          </option>
        ) : null}
        {/* {type === "pending" &&
          (userType === "admin" || userType === "wholesale_head") && (
            <option value="edit-ps" className="color-options">
              Edit
            </option>
          )} */}
        {type === "bounced" &&
          (userType === "admin" || userType === "wholesale_head") && (
            <option value="return-ps" className="color-red">
              Return to pending
            </option>
          )}
        {(type === "pending" || type === "bounced") &&
          (userType === "admin" || userType === "wholesale_head") && (
            <option value="delete-ps" className="color-red">
              Delete
            </option>
          )}
      </Form.Select>
    )
  }

  async function handleGenerateBir2037() {
    if (selectedRow) {
    } else {
    }
    setIsClicked(true)
    toast.loading("Printing Form 2307", { style: toastStyle() })
    // handleClosePrintModal()
    setTimeout(() => {
      toast.dismiss()
      Print()
    }, 1000)
  }

  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    refreshPage()
  }

  // async function handleGenerateBir2037() {
  //   setIsClicked(true)

  //   var paymentMode = selectedRow.type
  //   var id = selectedRow.id

  //   // yet to be changed
  //   var response = await createBir2037SalesPayment(id, paymentMode)
  //   if (response.data) {
  //     //extract data from response and then feed to excel
  //     toast.success("BIR 2037 generated successfully", {
  //       style: toastStyle(),
  //     })
  //     setTimeout(() => refreshPage(), 1000)
  //     // handleExcelGeneration(response)
  //     //after a successfull generation close modal
  //   } else {
  //     // response.error?.response?.data?.messages.map((data) => {
  //     //   return toast.error(data)
  //     // })
  //     // setTimeout(() => refreshPage(), 1000);
  //   }
  //   setIsClicked(false)
  // }

  function ViewPayment(row) {
    return (
      <button
        type="button"
        className="button-primary view-btn me-3"
        onClick={() => handleViewPayment(row.id, row.payment_mode)}
      >
        View
      </button>
    )
  }
  function handleViewPayment(id, payment_mode) {
    navigate("/salespayment/view/" + id + "/" + payment_mode.split(" ")[0])
  }

  function BouncedBtn(row) {
    return (
      <button
        type="button"
        className="button-primary view-btn me-3"
        onClick={() => {
          handleShowApproveModal(row, "disapproved")
        }}
      >
        Bounced
      </button>
    )
  }

  function VoidBtn(row) {
    return (
      <button
        type="button"
        className="button-primary view-btn me-3"
        onClick={() => {
          handleShowApproveModal(row, "disapproved")
        }}
      >
        Bounced
      </button>
    )
  }

  async function handleChangeCheckStatus() {
    const response = await updateCheckSlipStatus(selectedRow.id, statusValue)
    if (response.data) {
      toast.success(response.data.message, {
        style: toastStyle(),
      })
      setTimeout(() => refreshPage(), 1000)
    } else {
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data)
      })
      setTimeout(() => refreshPage(), 1000)
    }
  }

  function ApprovedBtn(row) {
    return (
      <button
        type="button"
        className="button-primary view-btn me-3"
        onClick={() => {
          handleShowApproveModal(row, "approved")
        }}
      >
        Cleared
      </button>
    )
  }

  function handleAddChange(e) {
    navigate("/salespayment/add/" + e.target.value)
  }

  function InvoiceBtn(row) {
    return (
      <div className="d-flex flex-column gap-1">
        {row.invoices.map((invoice, index) => (
          <button
            key={index}
            type="button"
            className="invoice-button w-full"
            onClick={() => handleViewReturn(invoice.invoice_id)}
          >
            {`INV-${invoice.invoice_no}`}
          </button>
        ))}
      </div>
    )
  }

  function handleViewReturn(id) {
    const url = "/wholesaleinvoice/print/" + id
    window.open(url, "_blank")
  }

  const handleFilterChange = (e, select) => {
    if (select) {
      setFilterConfig((prev) => {
        return {
          ...prev,
          [e.name]: e.value,
          [e.select_variable]: {
            label: e.label,
            value: e.value,
          },
        }
      })
    } else {
      const { name, value } = e.target
      setFilterConfig((prev) => {
        return {
          ...prev,
          [name]: value,
        }
      })
    }
  }

  useEffect(() => {
    fetchData()
  }, [filterConfig, currentPage])

  useEffect(() => {
    fetchCustomers()
  }, [])

  const handleTabSelect = (tabKey) => {
    setCurrentPage(1)
    setCurrentTab(tabKey)
    setFilterConfig((prev) => {
      return {
        ...prev,
        tab: tabKey,
        status: tabKey,
        branch_id: "",
        // date_from: tabKey === "" ? aweekago : "",
        // date_to: tabKey === "" ? today : "",
        date_from: dateFilter.date_from,
        date_to: dateFilter.date_to,
        page: 1,
      }
    })
  }

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"SALES"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              SALES PAYMENTS{" "}
            </h1>
          </Col>
          <Col
            xs={12}
            lg={3}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3"
          >
            <input
              type="search"
              className="search-bar"
              name="doc_no"
              placeholder="Search doc no..."
              // onChange={(e) => handleFilterChange(e)}
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") &&
                handleFilterChange(e, false)
              }
            />
          </Col>
          <Col lg={2} className="mt-4 mt-lg-0">
            <div className="PO-filters">
              <Form.Select
                // className="add-select"
                className="me-3 add-type"
                onChange={(e) => handleAddChange(e)}
              >
                <option value="" hidden selected>
                  Add
                </option>
                <option value="bank">Bank to Bank</option>
                <option value="cash">Cash</option>
                <option value="check">Check</option>
                <option value="others">Others</option>
              </Form.Select>
            </div>
          </Col>
        </Row>

        <Tabs
          activeKey={filterConfig.tab}
          defaultActiveKey={filterConfig.tab}
          className="mt-3 mt-md-5 PO-tabs"
          id="PO-tabs"
          onSelect={handleTabSelect}
        >
          <Tab
            eventKey="pending"
            title="pending"
            className="red __table-container"
          >
            {/* table */}
            {/* filters */}
            <div className="mb-3" />
            <span className="mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row my-1">
              <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="All Branches"
                  styles={selectDropdownStyle}
                  value={filterConfig.customer_id_value}
                  options={customers}
                  onChange={(e) => handleFilterChange(e, true)}
                />
              </Col>
              <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                <Form.Select
                  name="payment_mode"
                  className="date-filter force-width w-full"
                  onChange={(e) => handleFilterChange(e, false)}
                  value={filterConfig.payment_mode}
                >
                  <option value="" hidden selected>
                    Payment Mode
                  </option>
                  <option value="">All</option>
                  <option value="bank">Bank</option>
                  <option value="cash">Cash</option>
                  <option value="check">Check</option>
                  <option value="other">Other</option>
                </Form.Select>
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="date_from"
                  className="date-filter me-4 form-control"
                  // placeholderText="Select Date"
                  selected={filterConfig.date_from}
                  onChange={(date) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date }
                    })
                  }}
                  placeholderText="Select Date From"
                  showYearDropdown
                  dateFormat="MMMM dd, yyyy"
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="date_to"
                  className="date-filter ps-label-content me-5 form-control"
                  // placeholderText="Select Date"
                  selected={filterConfig.date_to}
                  onChange={(date) => {
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date }
                    })
                  }}
                  placeholderText="Select Date To"
                  showYearDropdown
                  dateFormat="MMMM dd, yyyy"
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className=" PO-filters d-flex justify-content-center">
              <span className="me-4 ml-4 mt-2 ps-label">
                Total Amount: {summary === 0 ? "0.00" : numberFormat(summary)}
              </span>
            </div>
            <div className="mb-2" />
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "/",
                "DATE ISSUED",
                "CUSTOMER",
                "PAYEE",
                "AMT",
                "PYMNT MODE",
                "APPLIED TO THE FF INVOICES",
                "BANK NAME",
                "DATE ADDED",
                "DOC NO.",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "/",
                "issue_date",
                "customer",
                "payee",
                "amount",
                "payment_mode",
                "invoice_numbers",
                "bank_name",
                "date",
                "doc_no",
              ]}
              tableData={filteredData}
              ActionBtn={(row) => ActionBtn(row, "pending")}
              ViewBtn={(row) => ApprovedBtn(row)}
              DoneBtn={(row) => BouncedBtn(row)}
              newTabBtn={(row) => InvoiceBtn(row)}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>
          <Tab
            eventKey="approved"
            title="cleared"
            className="__table-container"
          >
            {/* table */}
            {/* filters */}
            <div className="mb-3" />
            <span className="mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row my-1">
              <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="All Branches"
                  styles={selectDropdownStyle}
                  value={filterConfig.customer_id_value}
                  options={customers}
                  onChange={(e) => handleFilterChange(e, true)}
                />
              </Col>
              <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                <Form.Select
                  name="payment_mode"
                  className="date-filter force-width w-full"
                  onChange={(e) => handleFilterChange(e, false)}
                  value={filterConfig.payment_mode}
                >
                  <option value="" hidden selected>
                    Payment Mode
                  </option>
                  <option value="">All</option>
                  <option value="bank">Bank</option>
                  <option value="cash">Cash</option>
                  <option value="check">Check</option>
                  <option value="other">Other</option>
                </Form.Select>
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="date_from"
                  className="date-filter me-4 form-control"
                  // placeholderText="Select Date"
                  selected={filterConfig.date_from}
                  onChange={(date) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date }
                    })
                  }}
                  dateFormat="MMMM dd, yyyy"
                  placeholderText="Select Date From"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="date_to"
                  className="date-filter ps-label-content me-5 form-control"
                  // placeholderText="Select Date"
                  selected={filterConfig.date_to}
                  onChange={(date) => {
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date }
                    })
                  }}
                  placeholderText="Select Date To"
                  showYearDropdown
                  dateFormat="MMMM dd, yyyy"
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className=" PO-filters d-flex justify-content-center">
              <span className="me-4 ml-4 mt-2 ps-label">
                Total Amount: {summary === 0 ? "0.00" : numberFormat(summary)}
              </span>
            </div>
            <div className="mb-2" />
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "DATE ISSUED",
                "CUSTOMER",
                "PAYEE",
                "AMT",
                "PYMNT MODE",
                "APPLIED TO THE FF INVOICES",
                "BANK NAME",
                "DATE ADDED",
                "DOC NO.",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "issue_date",
                "customer",
                "payee",
                "amount",
                "payment_mode",
                "invoice_numbers",
                "bank_name",
                "date",
                "doc_no",
              ]}
              tableData={filteredData}
              ActionBtn={(row) => ActionBtn(row, "approved")}
              ViewBtn={(row) => ViewPayment(row)}
              DoneBtn={(row) => BouncedBtn(row)}
              newTabBtn={(row) => InvoiceBtn(row)}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>
          <Tab
            eventKey="disapproved"
            title="bounced"
            className="__table-container"
          >
            {/* table */}
            {/* filters */}
            <div className="mb-3" />
            <span className="mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row my-1">
              <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="All Branches"
                  styles={selectDropdownStyle}
                  value={filterConfig.customer_id_value}
                  options={customers}
                  onChange={(e) => handleFilterChange(e, true)}
                />
              </Col>
              <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                <Form.Select
                  name="payment_mode"
                  className="date-filter force-width w-full"
                  onChange={(e) => handleFilterChange(e, false)}
                  value={filterConfig.payment_mode}
                >
                  <option value="" hidden selected>
                    Payment Mode
                  </option>
                  <option value="">All</option>
                  <option value="bank">Bank</option>
                  <option value="cash">Cash</option>
                  <option value="check">Check</option>
                  <option value="other">Other</option>
                </Form.Select>
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="date_from"
                  className="date-filter me-4 form-control"
                  // placeholderText="Select Date"
                  selected={filterConfig.date_from}
                  onChange={(date) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date }
                    })
                  }}
                  placeholderText="Select Date From"
                  showYearDropdown
                  dateFormat="MMMM dd, yyyy"
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="date_to"
                  className="date-filter ps-label-content me-5 form-control"
                  // placeholderText="Select Date"
                  selected={filterConfig.date_to}
                  onChange={(date) => {
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date }
                    })
                  }}
                  placeholderText="Select Date To"
                  showYearDropdown
                  dateFormat="MMMM dd, yyyy"
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className=" PO-filters d-flex justify-content-center">
              <span className="me-4 ml-4 mt-2 ps-label">
                Total Amount: {summary === 0 ? "0.00" : numberFormat(summary)}
              </span>
            </div>
            <div className="mb-2" />
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "DATE ISSUED",
                "CUSTOMER",
                "PAYEE",
                "AMT",
                "PYMNT MODE",
                "APPLIED TO THE FF INVOICES",
                "BANK NAME",
                "DATE ADDED",
                "DOC NO.",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "issue_date",
                "customer",
                "payee",
                "amount",
                "payment_mode",
                "invoice_numbers",
                "bank_name",
                "date",
                "doc_no",
              ]}
              tableData={filteredData}
              ActionBtn={(row) => ActionBtn(row, "bounced")}
              ViewBtn={(row) => ViewPayment(row)}
              newTabBtn={(row) => InvoiceBtn(row)}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>
          <Tab eventKey="all" title="All" className="__table-container">
            {/* table */}
            {/* filters */}
            <div className="mb-3" />
            <span className="mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row my-1">
              <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="All Branches"
                  styles={selectDropdownStyle}
                  value={filterConfig.customer_id_value}
                  options={customers}
                  onChange={(e) => handleFilterChange(e, true)}
                />
              </Col>
              <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                <Form.Select
                  name="payment_mode"
                  className="date-filter force-width w-full"
                  onChange={(e) => handleFilterChange(e, false)}
                  value={filterConfig.payment_mode}
                >
                  <option value="" hidden selected>
                    Payment Mode
                  </option>
                  <option value="">All</option>
                  <option value="bank">Bank</option>
                  <option value="cash">Cash</option>
                  <option value="check">Check</option>
                  <option value="other">Other</option>
                </Form.Select>
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="date_from"
                  className="date-filter me-4 form-control"
                  // placeholderText="Select Date"
                  selected={filterConfig.date_from}
                  onChange={(date) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date }
                    })
                  }}
                  placeholderText="Select Date From"
                  showYearDropdown
                  dateFormat="MMMM dd, yyyy"
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="date_to"
                  className="date-filter ps-label-content me-5 form-control"
                  // placeholderText="Select Date"
                  selected={filterConfig.date_to}
                  onChange={(date) => {
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date }
                    })
                  }}
                  placeholderText="Select Date To"
                  showYearDropdown
                  dateFormat="MMMM dd, yyyy"
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className=" PO-filters d-flex justify-content-center">
              <span className="me-4 ml-4 mt-2 ps-label">
                Total Amount: {summary === 0 ? "0.00" : numberFormat(summary)}
              </span>
            </div>
            <div className="mb-2" />
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "DATE ISSUED",
                "CUSTOMER",
                "PAYEE",
                "AMT",
                "PYMNT MODE",
                "APPLIED TO THE FF INVOICES",
                "BANK NAME",
                "DATE ADDED",
                "DOC NO.",
                // "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "issue_date",
                "customer",
                "payee",
                "amount",
                "payment_mode",
                "invoice_numbers",
                "bank_name",
                "date",
                "doc_no",
              ]}
              tableData={filteredData}
              // ActionBtn={(row) => ActionBtn(row, "all")}
              ViewBtn={(row) => ViewPayment(row)}
              newTabBtn={(row) => InvoiceBtn(row)}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>
        </Tabs>
      </div>

      {/* modals */}
      <Delete
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        text="payment"
        onDelete={handleDeleteSP}
        isClicked={isClicked}
      />
      <VoidModal
        show={showVoidModal}
        onHide={handleCloseVoidModal}
        text="payment"
        onDelete={() => handleVoidSP()}
        isClicked={isClicked}
      />
      <ApproveModal
        show={showApproveModal}
        hide={handleCloseApproveModal}
        text={`change this sales payment status to ${
          statusValue === "disapproved"
            ? "bounced"
            : statusValue === "approved"
            ? "cleared"
            : statusValue
        }`}
        // text="change this sales payment status to"
        handler={() => handleChangeCheckStatus()}
        isClicked={isClicked}
      />
      <GenerateBirModal
        show={showGenerateBirModal}
        hide={() => handleCloseGenerateBirModal()}
        message="Are you sure you want to Generate BIR 2307 for this purchase invoice?"
        handler={() => handleGenerateBir2037()}
        isClicked={isClicked}
      />

      {/* <approved */}
      <BirForm
        id={selectedRow.id}
        type="sales-payment"
        mode={selectedRow.type}
      />
      <Footer />
    </div>
  )
}
